class RoleModel {
  name!: string;
  displayName!: string;
  description?: any;
  id!: number;
  profileImageID!: number;
}

export default RoleModel;
